<!--
    Program: BulletinView.vue
    Author: SDL
    Description: 
    Created: 2020.03.13
-->

<template>
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <h2 class="pg_title">Service Bulletin - Mobile (English) Detail</h2>
            <!-- breadcrumbs -->
            <div class="bc_ico">
                Home
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Engineer
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Service Bulletin
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Mobile (English) Detail
            </div>
            <!-- //breadcrumbs -->
            <!-- //contents_head -->
            <!-- detail_f tit -->
            <div class="sub_tit">Basic Info.</div>
            <!-- //detail_f tit -->
            <!-- detail_f -->
            <table class="create_table">
                <colgroup>
                    <col width="15%" />
                    <col width="*" />
                    <col width="15%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>Date</th>
                        <td>{{view.reg_dt}}</td>
                        <th>Register</th>
                        <td>{{view.reg_user_id}}</td>
                    </tr>
                    <tr>
                        <th>Type</th>
                        <td>{{view.type1}} / {{view.type2}}</td>
                        <th></th>
                        <th></th>
                    </tr>
                    <tr>
                        <th>Urgency</th>
                        <td>
                            <label
                                :class="{ txt_red: view.urgency_yn === 'Y' }"
                                v-if="view.urgency_yn === 'Y'"
                            >Urgent</label>
                            <label v-else>Normal</label>
                        </td>
                        <th>Need Translation</th>
                        <td>
                            <label
                                :class="{ txt_red: view.need_reprocess === 'Y' }"
                            >{{view.need_reprocess}}</label>
                        </td>
                    </tr>
                    <tr>
                        <th>Required Translations</th>
                        <td colspan="3" class="txt_red">{{view.tran}}</td>
                    </tr>
                    <tr>
                        <th>Title</th>
                        <td colspan="3">{{view.title | refTitle | decodeXSS }}</td>
                    </tr>
                    <tr>
                        <th>Tag Info</th>
                        <td colspan="3">{{view.tag_info}}</td>
                        <!-- <th>Sort</th>
                        <td>Move to the top</td>-->
                    </tr>
                    <tr>
                        <th>User Level</th>
                        <td colspan="3">
                            <ul class="ul_list max_scrollbar">
                                <li
                                    class="userlevel_txt"
                                    v-for="level in userLevelList"
                                    :key="level.CODE_ID"
                                >{{level.CODE_ID}} ({{level.CODE_NAME}})</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>Country / Region</th>
                        <td colspan="3">
                            <ul class="ul_list max_scrollbar">
                                <li
                                    class="userlevel_txt"
                                    v-for="country in countryList"
                                    :key="country"
                                >{{country}}</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>Contents</th>
                        <td colspan="3">
                            <span v-html="view.content"></span>
                            <!-- <cross-editor-viewer
                                :editorId="'editorId-'+view.seq"
                                :editorData="view.content || getBlankTemplate"
                            /> -->
                        </td>
                    </tr>
                    <tr>
                        <th>Attachment</th>
                        <td colspan="3" class="no_padding">
                            <innorix-download
                                v-if="fileList.length > 0"
                                :id="view.seq"
                                :name="view.seq" 
                                :uploadId="view.seq"
                                serviceType="hhpsvc"
                                :attachList="fileList"
                                :seq="view.seq"
                            />
                            <span v-else>
                                No Attachment
                            </span>
                            <!-- <div class="attachment_wrap">
                            <img src="images/@attachment.png" alt />
                            </div>-->

                            <dl class="attachment_link" v-if="fileList.length > 0">
                                <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">Having trouble downloading?</a></dt>
                                <dd>
                                    <ul>
                                        <li v-for="file in fileList" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                            <!-- <a :href="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" download="true" target="_blank" class="txt_link"> -->
                                            <a href="javascript:" @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" class="txt_link">
                                                <span class="ico_attach"></span> {{ file.FILE_NM }}
                                            </a>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- //detail -->
            <!-- page btn -->
            <div class="btn_wrap_full topLine">
                <a href="javascript:" class="btn_white" title @click="onBackToListClick">List</a>
                <div v-if="['A16', 'S05'].includes(roleCd)" class="btn_right">
                    <fragment>
                        <a
                            href="javascript:"
                            v-if="roleCd === 'S05'"
                            class="btn_white"
                            @click="onEditClick"
                        >Edit</a>
                        <a
                            href="javascript:"
                            v-if="roleCd === 'S05'"
                            class="btn_white"
                            @click="onDeleteClick"
                        >Delete</a>
                    </fragment>
                    <a href="javascript:" class="btn_blue" @click="onTranslateClick">Translate</a>
                </div>
            </div>
            <!-- //page btn -->
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import axios from 'axios';
import qs from 'query-string';

import store from '@/vuex/store';
import constants from '@/constants';
import SDLLocale from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';

import CrossEditorViewer from '~c/CrossEditorViewer';
import InnorixDownload from '~c/InnorixDownload';

import BlankPageTempPage from '/static/sample/CREATE_Template_04.html';

export default {
    name: 'hhp-bulletin-view',
    components: {
        'cross-editor-viewer': CrossEditorViewer,
        'innorix-download': InnorixDownload,
    },
    props: {
        seq: {
            type: String,
            required: true,
        },
        onBackToList: {
            type: Function,
            required: false,
        },
        // encToken: {
        //     type: String,
        //     required: true,
        // },
    },
    computed: {
        getBlankTemplate() {
            return BlankPageTempPage;
        },
    },
    data() {
        return {
            roleCd: '',
            view: {},
            countryList: [],
            userLevelList: [],
            fileList: [],
            encToken: '',

            delAttachFiles: [],
            isRemove: false,
        };
    },
    created() {
        console.log('Component:  created. ');
        this.init();
    },
    mounted() {
        console.log('Component:  mounted.');
    },
    methods: {
        async init() {
            const data = await this.fetchData();
            this.setData(data);
            // this.setUserList(data.userLevelList, );
        },

        fetchData() {
            const params = {
                seq: this.seq,
            };

            const path = '/basis/anysvcmobile/svcBulletin/sbView.skp';
            return SDLUtil.getRequest(path, params);
            // return (
            //     axios
            //         // Loads data such as list of countries, etc...
            //         .get(`${SDLUtil.API_URL}/basis/anysvcmobile/svcBulletin/sbView.skp`, { params })
            //         .then(res => {
            //             console.log('SvcBulletin RESPONSE', res);
            //             // res.data.rows => [['CODE_NAME', 'CODE_ID'], ...]
            //             // console.log('LOG', this.availableParentCodeList);
            //             return res.data;
            //         })
            //     // .catch(err => {
            //     //     console.log(`SvcBulletin ERROR =>>`, err);
            //     //     return res.data;
            //     // })
            // );
        },

        setData(data) {
            this.roleCd = data.roleCd;

            this.view = data.view;
            this.view.tran = data.view.tran
                .split(',')
                .filter(item => item)
                .map(item => item.replace(/ /g, ''))
                .join(', ');
            // this.view.tran = data.view.tran.replace(',', ''); // replace the first comman.
            this.view.content = SDLUtil.stripHtml(data.view.content);

            this.encToken = data.encToken;
            this.fileList = data.fileList.map(item => {
                item.seq = this.view.seq;
                return item;
            });
            console.log('fileList', this.fileList);

            // console.log('this.view.tran', this.view.tran);
            this.countryList = data.country.map(item => item.COUNTRY_NM).sort();
            // console.log('countryList', this.countryList);
            this.userLevelList = data.userLevelList.map(item => {
                const matched = data.userLevelLabelList.find(i => i.CODE_ID === item.USER_LEVEL);
                return {
                    CODE_ID: item.USER_LEVEL,
                    CODE_NAME: matched ? matched.CODE_NAME : '',
                };
            });
            console.log('userLevelList', this.userLevelList);
        },

        

        onEditClick() {
        	 if (this.view.status === 'R') {
                 SDLUtil.alert('This Service Bulletin Mobile is under approval and cannot be modified.');
                 return true;
             }
            this.$router.push({
                name: 'hhpServiceBulletinEdit',
                query: {
                    seq: this.seq,
                },
            });
        },

        onDeleteClick() {
        	 if (this.view.status === 'R') {
                 SDLUtil.alert('This Service Bulletin Mobile is under approval and cannot be deleted.');
                 return true;
             }
            const onOkEvt = async () => {
                const data = await this.deleteContent();
                SDLUtil.alert({
                    title: 'Deleted!',
                    msg: data.message,
                    onOkEvt: () => this.onBackToListClick(),
                });
            };

            SDLUtil.confirm({
                title: 'Confirm',
                msg: 'Want to Delete?',
                okLabel: 'Delete',
                cancelLabel: 'No',
                onOkEvt,
            });
        },

        onTranslateClick() {
        	 if (!(this.view.status === 'S' ||  this.view.status === 'N/A')) {
                 SDLUtil.alert('This Service Bulletin Mobile is not approval and cannot be tanslated.');
                 return true;
             }
            this.$router.push({
                name: 'hhpServiceBulletinTranslate',
                query: {
                    seq: this.seq,
                },
            });
        },

        onBackToListClick() {
            if (typeof this.onBackToList === 'function') {
                this.onBackToList();
                return;
            }

            this.$router.push({
                name: 'hhpServiceBulletin',
            });
        },

        deleteContent() {
            const params = {
                seq: this.seq,
            };
            return (
                axios
                    // Loads data such as list of countries, etc...
                    .get(`${SDLUtil.API_URL}/basis/anysvcmobile/svcBulletin/sbDeleteProc.skp`,
                        { params })
                    .then(res => {
                        console.log('SvcBulletin DELETE', res);
                        // res.data.rows => [['CODE_NAME', 'CODE_ID'], ...]
                        // console.log('LOG', this.availableParentCodeList);
                        return res.data;
                    })
                // .catch(err => {
                //     console.log(`SvcBulletin ERROR =>>`, err);
                //     return res.data;
                // })
            );

        },

        setAttachFiles(val) {
            Vue.$log.info('▶ InnorixDownload.vue -> BulletinView.vue / files : ', val);
            this.fileList = val.fileList || [];
            this.delAttachFiles = val.delFileList || [];
            this.isRemove = val.isRemove || false;
        },

        toggleLink(e) {
            $('.attachment_link > dd').toggle();
        },

        getDownloadUrl(SEQ, TOKEN) {
            const params = {
                attachFileSeq: SEQ,
                encToken: TOKEN,
                anysvc: 'Y',
                seq: this.view.seq,
            };

            this.increaseHhpDownloadCount(this.view.seq);

            const downloadUrl = `${SDLUtil.API_URL}/basis/common/attachBulletinDownload.skp?${qs.stringify(params)}`;
            return window.open(downloadUrl);
        },

        increaseHhpDownloadCount(seq) {
            const hhpSvcDownloadCountApi = `${SDLUtil.API_URL}/basis/common/attachBulletinDownloadCount.skp?${qs.stringify({seq:seq})}`; // POST
            return axios.post(hhpSvcDownloadCountApi);
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/svcBulletin/BulletinView.vue